<template>
  <div class="h-full flex flex-col">
    <a-row :gutter="6" align="middle" style="margin-bottom: 20px" type="flex">
      <a-col class="col-item">
        <span>
          快速选择：
          <j-quick-time-range :style="{ width: '150px' }" @change="setFastRange" v-model="fastTimeRange" />
        </span>
      </a-col>
      <a-col class="col-item">
        <a-radio-group :value="sampleFunc" @change="changeSampleFunc">
          <a-radio value="avg">均值</a-radio>
          <a-radio value="max">最大</a-radio>
          <a-radio value="min">最小</a-radio>
        </a-radio-group>
      </a-col>
      <a-col class="col-item">
        <span>
          空值填充：
          <a-select :options="fillTypeOptions" type="list" v-model="fillType"  @change="loadPointsData"/>
        </span>
      </a-col>
      <a-col class="col-item">
        <span v-if="!this.$route.query.modelId">时间：</span>
        <a-range-picker
          :placeholder="['开始时间', '结束时间']"
          :show-time="{ format: 'HH:mm' }"
          @change="loadPointsData"
          @ok="loadPointsData"
          format="YYYY-MM-DD HH:mm"
          v-model="timeRange"
        />
      </a-col>
      <a-col :style="{ display: 'flex', 'align-items': 'center' }" class="col-item">
        <a-tooltip title="前一天">
          <a>
            <a-icon @click="timeChange(-24)" class="search-icon-m" type="backward" />
          </a>
        </a-tooltip>
        <a>
          <a-tooltip title="前2小时">
            <a-icon @click="timeChange(-2)" class="search-icon" type="caret-left" />
          </a-tooltip>
        </a>
        <a>
          <a-tooltip title="后2小时">
            <a-icon @click="timeChange(2)" class="search-icon" type="caret-right" />
          </a-tooltip>
        </a>
        <a>
          <a-tooltip title="后一天">
            <a-icon @click="timeChange(24)" class="search-icon-m" type="forward" />
          </a-tooltip>
        </a>
      </a-col>
      <a @click="handleToggleCompare" style="margin-left: 8px">
        {{ toggleCompareStatus ? '收起' : '分组' }}
        <a-icon :type="toggleCompareStatus ? 'up' : 'down'" />
      </a>
    </a-row>
    <a-row v-if="toggleCompareStatus">
      <a-row type="flex">
        <a-col style="margin: 0 10px;">
          <a-button @click="addCompare" icon="plus" size="small" type="primary">分组</a-button>
        </a-col>
        <a-col :key="i" style="margin: 0  10px 10px 10px;" v-for="(com, i) of compares">
          <a-tag color="#2db7f5">{{ com.name }}</a-tag>:
          <a-select
            :options="compareDictOptions"
            @change="changeCompareLineOpts"
            mode="multiple"
            size="small"
            style="min-width: 240px"
            v-model="com.points"
          />
          <a-button
            @click="delCompare(i)"
            icon="minus"
            shape="circle"
            size="small"
            style="margin-left: 10px;"
            type="danger"
          />
        </a-col>
      </a-row>
    </a-row>
    <div :bordered="false" class="card-container flex-1 overflow-y-scroll">
      <a-collapse :activeKey="chartPanelActived" :bordered="false">
        <!-- 多曲线比对面板 -->
        <a-collapse-panel
          :header="com.name"
          :key="index"
          :style="{ margin: '0 auto' }"
          size="small"
          v-for="(com, index) of compares"
        >
          <div class="w-full">
            <v-chart :option="compareLineOpts[index]" autoresize style="height:160px;" />
          </div>
        </a-collapse-panel>

        <!-- 单曲线面板 -->
        <a-collapse-panel
          :header="pointNames[pointId]"
          :key="pointId + '@' + index"
          :style="{ margin: '0 auto' }"
          size="small"
          v-for="(pointId, index) of checkedPoints"
        >
          <span slot="extra">
            <!-- 复制测点名称 -->
            <i
              @click="handleCopy($event, pointNames[pointId])"
              class="anticon-jeecg anticon-fuzhiwenzi"
              size="small"
              style="font-size: 20px;"
              title="复制点名"
              type="primary"
            />
            <!-- 复制点号 -->
            <i
              @click="handleCopy($event, pointId)"
              class="anticon-jeecg anticon-fuzhilianjiexian"
              size="small"
              style="font-size: 20px;margin-left:10px;"
              title="复制点号"
              type="primary"
            />
          </span>
          <div class="w-full">
            <v-chart
              :option="pointsLineOpts['p' + pointId]"
              @datazoom="handleDataZoom($event, pointId)"
              autoresize
              style="height:160px;"
            />
          </div>
        </a-collapse-panel>
      </a-collapse>
    </div>
  </div>
</template>

<script>
  import ACol from 'ant-design-vue/es/grid/Col'
  import { getAction } from '@/api/manage'
  import moment from 'dayjs'
  import { use } from 'echarts/core'
  import {
    LegendComponent,
    TitleComponent,
    ToolboxComponent,
    MarkPointComponent,
    MarkLineComponent
  } from 'echarts/components'
  import { LineChart } from 'echarts/charts'
  import VChart from 'vue-echarts'

  use([LineChart, LegendComponent, TitleComponent, ToolboxComponent, MarkPointComponent, MarkLineComponent])

  const chartColors = ['#91cc75', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#fac858', '#ee6666']
  const lineBaseOpts = {
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        let relVal = moment(params[0].value[0]).format('YYYY-MM-DD HH:mm:ss')
        for (let i = 0, l = params.length; i < l; i++) {
          // 遍历出来的值一般是字符串，需要转换成数字，再进项tiFixed四舍五入
          relVal +=
            '<br/>' +
            params[i].marker +
            params[i].seriesName +
            ' : ' +
            (params[i].value[1] == null ? '' : Number(params[i].value[1]).toFixed(3))
        }
        return relVal
      }
    },
    grid: {
      top: 50,
      left: 50,
      right: 20,
      bottom: 20
    },
    xAxis: {
      type: 'time'
    },
    toolbox: {
      show: true,
      feature: {
        dataZoom: {
          yAxisIndex: 'none'
        },
        dataView: {
          readOnly: false
        },
        magicType: {
          type: ['line', 'bar']
        },
        restore: {},
        saveAsImage: {}
      }
    }
  }

  export default {
    name: 'PointsLineChartForm',
    components: {
      ACol,
      VChart
    },
    data () {
      return {
        loading: true,
        modelId: '',
        timeRange: [
          moment()
            .add(-1, 'days')
            .format('YYYY-MM-DD HH:mm:ss'),
          moment().format('YYYY-MM-DD HH:mm:ss')
        ],
        fastTimeRange: 'noValue',
        checkedPoints: [],
        pointsLineOpts: {},
        pointNames: {},
        sampleFunc: 'avg',
        url: {
          getPointslist: '/monitor/iotModelPoints/list',
          getPointsGrouplist: '/monitor/iotModelPointsGroup/list',
          getPointData: '/monitor/data/pointdata'
        },
        alertTime: '',
        marks: null,
        toggleCompareStatus: false,
        compares: [],
        compareLineOpts: [],

        fillTypeOptions: [
          { label: '无填充连接', value: 'NONE' },
          { label: '无填充断开', value: 'NULL' },
          { label: '前一个值', value: 'PREV' },
          { label: '后一个值', value: 'NEXT' },
          { label: '线性插值', value: 'LINEAR' }
        ],
        fillType: 'NONE'
      }
    },
    computed: {
      compareDictOptions: function () {
        const options = this.checkedPoints.map(p => {
          return { value: p, label: this.pointNames[p] }
        })
        return options
      },
      chartPanelActived: function () {
        const keys1 = this.checkedPoints.map((pointId, index) => pointId + '@' + index)
        const keys2 = this.compares.map((com, index) => index)
        return keys1.concat(keys2)
      }
    },
    methods: {
      addCompare () {
        const index = this.compares.length
        this.compares.push({ name: `分组${index + 1}`, points: [] })
      },
      delCompare (i) {
        this.compares.splice(i, 1)
      },
      changeCompareLineOpts () {
        for (let index = 0; index < this.compares.length; index++) {
          const com = this.compares[index]
          const pointCodes = com.points
          if (!pointCodes) {
            continue
          }
          let series = []
          for (const key in this.pointsLineOpts) {
            if (Object.hasOwnProperty.call(this.pointsLineOpts, key)) {
              //将单个曲线中的series添加到这个对比组com的series中，根据点号匹配
              if (pointCodes.includes(key.substring(1))) {
                const opt = this.pointsLineOpts[key]
                series = series.concat(opt.series)
              }
            }
          }
          const lineOpts = Object.assign({}, lineBaseOpts, {
            series,
            yAxis: [
              {
                type: 'value'
              }
            ]
          })
          this.compareLineOpts.splice(index, 1, lineOpts)
        }
      },
      setFastRange (val) {
        this.timeRange.splice(0, 2, val[0], val[1])
        this.loadPointsData()
      },
      timeChange (hours) {
        const [startTime, endTime] = this.timeRange
        const newStartTime = moment(startTime)
          .add(hours, 'hours')
          .format('YYYY-MM-DD HH:mm')
        const newEndTime = moment(endTime)
          .add(hours, 'hours')
          .format('YYYY-MM-DD HH:mm')
        this.timeRange = [newStartTime, newEndTime]
        this.loadPointsData()
      },
      changeSampleFunc (e) {
        this.sampleFunc = e.target.value
        this.loadPointsData()
      },
      loadData (pointsStr, timeRange, alertTime, fastTimeRange, marks) {
        if (fastTimeRange) {
          this.fastTimeRange = fastTimeRange
        }
        this.alertTime = alertTime
        this.marks = marks
        this.checkedPoints = pointsStr ? pointsStr.split(',') : []
        if (timeRange) {
          this.timeRange.splice(0, 2, timeRange[0], timeRange[1])
        } else {
          const now = moment().format('YYYY-MM-DD HH:mm')
          const yesterday = moment()
            .add(-1, 'days')
            .format('YYYY-MM-DD HH:mm')
          this.timeRange.push(yesterday)
          this.timeRange.push(now)
        }
        this.loadPointsData()
      },
      loadPointsData () {
        const that = this
        const [startTime, endTime] = this.timeRange
        const diffSeconds = moment(endTime).diff(moment(startTime), 'second')
        let interval = Math.floor(diffSeconds / 2000)
        interval = Math.max(1, interval)

        const promises = this.checkedPoints.map((pointId, index) => {
          const parms = {
            startTime: moment(startTime).format('YYYY-MM-DD HH:mm:ss'),
            endTime: moment(endTime).format('YYYY-MM-DD HH:mm:ss'),
            points: pointId,
            interval,
            sampleFunc: this.sampleFunc,
            fillType: this.fillType
          }
          return getAction(this.url.getPointData, parms).then(res => {
            if (res.success) {
              res.result.forEach(info => {
                const series = []
                this.pointNames[pointId] = info.desc
                let seriesData = {
                  name: info.desc,
                  data: this.objectArrTo2Array(info.details),
                  type: 'line',
                  smooth: ['BOOL', 'int'].includes(info.dataType) ? false : true,
                  step: ['BOOL', 'int'].includes(info.dataType) ? 'end' : false,
                  showSymbol: false,
                  color: chartColors[index % chartColors.length],
                  markPoint: ['BOOL', 'int'].includes(info.dataType)
                    ? {
                      data: []
                    }
                    : {
                      data: [
                        { type: 'max', name: '最大值' },
                        { type: 'min', name: '最小值' }
                      ]
                    },
                  markLine: ['BOOL', 'int'].includes(info.dataType)
                    ? {
                      data: []
                    }
                    : {
                      data: [{ type: 'average', name: '平均值' }],
                      symbol: 'none', //取消警戒线箭头
                      silent: 'true', //图形是否不响应和触发鼠标事件，默认为 false，即响应和触发鼠标事件
                      label: {
                        position: 'insideEndBottom',
                        formatter: '{b}:{c}',
                        backgroundColor: chartColors[index % chartColors.length],
                        color: '#fff',
                        fontSize: 12,
                        padding: 4
                      }
                    }
                }
                if (this.marks) {
                  seriesData.markPoint.data = [...seriesData.markPoint.data, ...this.marks.markPoints[info.pointCode]]
                  seriesData.markLine.data = [...seriesData.markLine.data, ...this.marks.markLines[info.pointCode]]
                } else {
                  if (this.alertTime) {
                    const signMarkPoint = that.findCloseNum(info.details, moment(that.alertTime))
                    if (signMarkPoint) {
                      const signMarkPointData = {
                        name: '告警时刻',
                        yAxis: signMarkPoint.value,
                        xAxis: signMarkPoint.timeStamp,
                        value:
                          info.dataType === 'float32'
                            ? parseFloat(signMarkPoint.value).toFixed(3)
                            : parseInt(signMarkPoint.value),
                        itemStyle: {
                          color: 'red'
                        }
                      }
                      seriesData.markPoint.data.push(signMarkPointData)
                      const signMarkLine = {
                        name: '告警时刻',
                        xAxis: signMarkPoint.timeStamp,
                        itemStyle: {
                          color: 'red'
                        },
                        lineStyle: {
                          type: 'solid'
                        },
                        label: {
                          //  label属性 设置图线的样式
                          show: false
                        }
                      }
                      seriesData.markLine.data.push(signMarkLine)
                    }
                  }
                }

                series.push(seriesData)
                const lineOpts = Object.assign({}, lineBaseOpts, {
                  series,
                  yAxis: [
                    {
                      name: info.unit,
                      type: 'value'
                    }
                  ]
                })
                this.$set(this.pointsLineOpts, 'p' + info.pointCode, lineOpts)
              })
            }
          })
        })

        Promise.all(promises).then(() => {
          this.changeCompareLineOpts()
        })
      },
      handleToggleCompare () {
        this.toggleCompareStatus = !this.toggleCompareStatus
      },
      objectArrTo2Array (arrs) {
        const res = []
        arrs.forEach(arr => {
          const item = [arr.timeStamp, arr.value?.toFixed(3)]
          res.push(item)
        })
        return res
      },
      findCloseNum (arr, num) {
        var index = 0 // 保存最接近数值在数组中的索引
        var d_value = Number.MAX_VALUE // 保存差值绝对值，默认为最大数值
        for (var i = 0; i < arr.length; i++) {
          var new_d_value = Math.abs(moment(arr[i].timeStamp) - num) // 新差值
          if (new_d_value <= d_value) {
            // 如果新差值绝对值小于等于旧差值绝对值，保存新差值绝对值和索引
            if (new_d_value === d_value && moment(arr[i].timeStamp) < moment(arr[index].timeStamp)) {
              // 如果数组中两个数值跟目标数值差值一样，取大
              continue
            }
            index = i
            d_value = new_d_value
          }
        }
        return arr[index] // 返回最接近的数值
      },
      handleCopy (event, val) {
        event.preventDefault()
        event.stopPropagation()
        let oInput = document.createElement('input')
        oInput.value = val
        document.body.appendChild(oInput)
        oInput.select() // 选择对象
        document.execCommand('Copy') // 执行浏览器复制命令
        this.$message.success('复制成功{' + val + '}')
        oInput.remove()
      },
      handleDataZoom (event, pointId) {
        // 处理 dataZoom 事件的逻辑
        const that = this
        const { startValue, endValue, start, end } = event.batch[0]
        if (start == 0 && end == 100) {
          that.loadPointsData()
          return
        }
        let startTime = moment(startValue).format('YYYY-MM-DD HH:mm:ss')
        let endTime = moment(endValue).format('YYYY-MM-DD HH:mm:ss')
        const diffSeconds = moment(endTime).diff(moment(startTime), 'second')
        let interval = Math.floor(diffSeconds / 2000)
        interval = Math.max(1, interval)
        const parms = {
          startTime: startTime,
          endTime: endTime,
          points: pointId,
          interval,
          sampleFunc: that.sampleFunc,
          fillType: this.fillType
        }
        that.changeDataZoom(parms)
      },
      changeDataZoom (parms) {
        const that = this
        let index = -1
        const pointId = parms.points
        //确定放大区域pointId的index序号
        for (let i = 0; i < that.checkedPoints.length; i++) {
          if (that.checkedPoints[i] == pointId) {
            index = i
            break
          }
        }
        getAction(this.url.getPointData, parms).then(res => {
          if (res.success) {
            res.result.forEach(info => {
              const series = []
              this.pointNames[pointId] = info.desc
              let seriesData = {
                name: info.desc,
                data: this.objectArrTo2Array(info.details),
                type: 'line',
                smooth: ['BOOL', 'int'].includes(info.dataType) ? false : true,
                step: ['BOOL', 'int'].includes(info.dataType) ? 'end' : false,
                showSymbol: false,
                color: chartColors[index % chartColors.length],
                markPoint: ['BOOL', 'int'].includes(info.dataType)
                  ? {
                    data: []
                  }
                  : {
                    data: [
                      { type: 'max', name: '最大值' },
                      { type: 'min', name: '最小值' }
                    ]
                  },
                markLine: ['BOOL', 'int'].includes(info.dataType)
                  ? {
                    data: []
                  }
                  : {
                    data: [{ type: 'average', name: '平均值' }],
                    symbol: 'none', //取消警戒线箭头
                    silent: 'true', //图形是否不响应和触发鼠标事件，默认为 false，即响应和触发鼠标事件
                    label: {
                      position: 'insideEndBottom',
                      formatter: '{b}:{c}',
                      backgroundColor: chartColors[index % chartColors.length],
                      color: '#fff',
                      fontSize: 12,
                      padding: 4
                    }
                  }
              }
              if (this.marks) {
                seriesData.markPoint.data = [...seriesData.markPoint.data, ...this.marks.markPoints[info.pointCode]]
                seriesData.markLine.data = [...seriesData.markLine.data, ...this.marks.markLines[info.pointCode]]
              } else {
                if (this.alertTime) {
                  const signMarkPoint = that.findCloseNum(info.details, moment(that.alertTime))
                  if (signMarkPoint) {
                    const signMarkPointData = {
                      name: '告警时刻',
                      yAxis: signMarkPoint.value,
                      xAxis: signMarkPoint.timeStamp,
                      value:
                        info.dataType === 'float32'
                          ? parseFloat(signMarkPoint.value).toFixed(3)
                          : parseInt(signMarkPoint.value),
                      itemStyle: {
                        color: 'red'
                      }
                    }
                    seriesData.markPoint.data.push(signMarkPointData)
                    const signMarkLine = {
                      name: '告警时刻',
                      xAxis: signMarkPoint.timeStamp,
                      itemStyle: {
                        color: 'red'
                      },
                      lineStyle: {
                        type: 'solid'
                      },
                      label: {
                        //  label属性 设置图线的样式
                        show: false
                      }
                    }
                    seriesData.markLine.data.push(signMarkLine)
                  }
                }
              }

              series.push(seriesData)
              this.$set(this.pointsLineOpts, 'p' + info.pointCode, {
                tooltip: {
                  trigger: 'axis',
                  formatter: function (params) {
                    let relVal = moment(params[0].value[0]).format('YYYY-MM-DD HH:mm:ss')
                    for (let i = 0, l = params.length; i < l; i++) {
                      // 遍历出来的值一般是字符串，需要转换成数字，再进项tiFixed四舍五入
                      relVal +=
                        '<br/>' +
                        params[i].marker +
                        params[i].seriesName +
                        ' : ' +
                        (params[i].value[1] == null ? '' : Number(params[i].value[1]).toFixed(3)) +
                        (info.unit ? info.unit : '')
                    }
                    return relVal
                  }
                },
                //   title: {
                //     text: info.desc,
                //     left: 'center',
                //     textStyle: {
                //       fontWeight: 500
                //     }
                //   },

                grid: {
                  top: 50,
                  left: 50,
                  right: 20,
                  bottom: 20
                },
                xAxis: {
                  type: 'time'
                },
                yAxis: [
                  {
                    // name: info.unit,
                    type: 'value'
                  }
                ],
                series: series,
                toolbox: {
                  show: true,
                  feature: {
                    dataZoom: {
                      yAxisIndex: 'none'
                    },
                    dataView: {
                      readOnly: false
                    },
                    magicType: {
                      type: ['line', 'bar']
                    },
                    restore: {},
                    saveAsImage: {}
                  }
                }
              })
            })
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .ant-collapse-borderless {
    background-color: #fff;
    height: 100%;
    overflow-y: auto;
  }

  .col-item {
    margin-left: 20px;

    .search-icon {
      font-size: 24px;
    }

    .search-icon-m {
      font-size: 28px;
    }
  }
  .extra-wrapper {
    line-height: 55px;
    padding-right: 24px;

    .extra-item {
      display: inline-block;
      margin-right: 24px;

      a {
        margin-left: 24px;
      }
    }
  }

  .ant-collapse-content > .ant-collapse-content-box {
    padding: 0;
  }
</style>
